import { PropsWithChildren, useState } from "react";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import './productParts.scss'
import { formatPrice } from "../../helpers/formatPrice";
import { useAppSelector } from "../../services/hooks";
import { Link } from "react-router";
import { InfoProductType } from "../../stores/product/productSlice.types";
import { useTranslation } from "react-i18next";

interface ProductPartsProps {
    title: string;
    colorClass: string;
    data: InfoProductType['parts'] | InfoProductType['accessories'] | InfoProductType['kits']
    activePart?: number | null;
    defaultView?: string,
}

export default function ProductTable({ children, title, colorClass, data, activePart, defaultView }: PropsWithChildren<ProductPartsProps>) {
    const { t } = useTranslation('productPage')
    const [view, setView] = useState(defaultView || 'list')

    const currency = useAppSelector((state) => state.user.currency)

    function changeClass(listClass: string, gridClass: string) {
        if (view === 'list') {
            return (listClass)
        }
        if (view === 'grid') {
            return (gridClass)
        }
    }

    const showItems = data?.map((item, index) => {
        const priceNet = item?.price?.net;
        const priceBlur = item?.options?.isPriceHidden
        if (item) return (
            <>
                <div
                    style={{ scrollMarginTop: "40vh" }}
                    key={index}
                    className={changeClass(
                        ("col-12 g-0 p-1 py-1 rounded-3"),
                        ("col-12 col-md-6 col-xl-3 p-4 rounded-3"),
                    )}
                    id={children && item.schemaId ? (item.schemaId).toString() : undefined}
                //data-prod-schema=""
                >
                    <Link
                        // TODO: inny link gdy pusty z serwera
                        to={`/product/${item.url ?? ""}`}
                        className={changeClass(
                            "noUnderline row  g-0 d-flex align-items-stretch rounded-2 link-light bg-white",
                            "noUnderline link-light bg-white")}>
                        <div className={changeClass(
                            `col-3 row  order-last rounded-end-2 mx-0 g-0 bgComplementaryWarrning${colorClass} align-items-center`,
                            "row small")}>
                            <span
                                className={changeClass(
                                    "text-center d-block  text-break  text-black  rounded-2 rounded-start-0",
                                    `text-center small bgComplementaryWarrning${colorClass} w-50 ms-auto py-1 rounded-top-3 text-black`
                                )}
                            >
                                <strong>{t('code')}</strong>
                                {item.code}
                            </span>
                        </div>
                        <div
                            className={changeClass(
                                (item.schemaId && item.schemaId === activePart ? "col-9 rounded-2 align-items-center row  order-first  m-0 p-0 rounded-end-0 bgComplementaryWarrningThird" : "col-9 rounded-2 align-items-center row  order-first  m-0 p-0 rounded-end-0 "),
                                (item.schemaId && item.schemaId === activePart ? "row border shadow-sm border-secondary-subtle rounded-bottom-4 rounded-start-4 px-3 py-2 bgComplementaryWarrningThird" : "row border shadow-sm border-secondary-subtle bg-white rounded-bottom-4 rounded-start-4 px-3 py-2"),
                            )}
                        >
                            <div
                                className={changeClass(
                                    "col-4 col-md-1 order-0 text-center px-0",
                                    "col-2 order-0  text-center px-0"
                                )}>
                                <div
                                    className={changeClass(
                                        "border border-2 border-secondary-subtle  boxRem boxRemDwa rounded-circle mx-auto",
                                        "border border-2 border-secondary-subtle boxRem boxRemDwa rounded-circle "
                                    )}>
                                    <div>
                                        <span
                                            className={changeClass(
                                                "bi bi-box text-dark-emphasis",
                                                "bi bi-box text-dark-emphasis fs-5 "
                                            )}></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={changeClass(
                                    "col-4 col-md-1 order-1 p-1",
                                    "col-6 order-2 px-0 g-0 pb-3"
                                )}>
                                <img
                                    src={item.image ? `/products/mini_karta/${item.image}` : `/tpl/assets/img/RomerProductFoto.png`}
                                    className={changeClass(
                                        "img-fluid border border-3 border-secondary border-opacity-25  rounded-circle",
                                        "img-fluid shadow-sm rounded-3 mt-1"
                                    )} />
                            </div>
                            <div
                                className={changeClass(
                                    "col-4 col-md-1  m-0  px-0 py-1 text-dark-emphasis fw-medium text-center align-self-center mt-0 order-2 g-0",
                                    "col-10 ps-0   text-dark-emphasis fw-medium text-center  align-self-center  mt-0 order-1"
                                )}>
                                {item.schemaId}
                            </div>
                            <div
                                className={changeClass(
                                    "col-12 col-md-6 link-dark g-0 order-3",
                                    "col-6  pt-1 link-dark hardCodeHeight9rem order-3"
                                )}>
                                <div
                                    className={changeClass(
                                        "fs-6  text-center text-md-start p-2 py-md-0 text-break textTruncateTwoLine",
                                        "small"
                                    )}>{item.name}</div>
                            </div>
                            <div
                                className={changeClass(
                                    "col-12 col-md-3 text-center  g-0  order-4",
                                    "col fs-5 text-center  align-self-center mt-2 mt-md-0 order-4"
                                )}>
                                <span
                                    className={changeClass(
                                        "link-dark px-2 text-break fs-6",
                                        "link-dark"
                                    )}>
                                    <strong style={priceBlur ? { filter: "blur(7px)" } : {}}>
                                        {
                                            typeof priceNet === 'number'
                                                ? formatPrice(priceNet, currency)
                                                : priceNet
                                        }
                                        <span className="small">
                                            <small className="text-muted"> / {item.unit}</small>
                                        </span>
                                    </strong>
                                </span>
                            </div>
                        </div>
                    </Link >
                </div >
            </>
        )
    })

    return (
        <>
            {children}
            <Row className="my-3 p-3 p-md-0">
                <Row className="text-start gx-0">
                    <Col xs={6} className={`bgComplementaryWarrning${colorClass} ms-0 me-auto rounded-top-3 text-black fs-5 fw-semibold ps-2 ps-md-5 py-2`}>
                        <span className="bi bi-layers responsivD-none"></span>
                        <span className="ps-1 ps-md-3 partFont"> {title}</span>
                    </Col>
                    <Col xs={6} className="text-end pb-1">
                        <Button
                            variant={view === "grid" ? "success" : "light"}
                            className="bi-grid-3x3 rounded-3 fs-5 switch-grid-list"
                            data-target="rowParts"
                            data-type="grid"
                            onClick={() => setView('grid')}
                        ></Button>
                        <Button
                            variant={view === "list" ? "success" : "light"}
                            className="bi-list-ul rounded-3 fs-5 switch-grid-list"
                            data-target="rowParts"
                            data-type="list"
                            onClick={() => setView('list')}
                        ></Button>
                    </Col>
                </Row>
                <Col xs={12} id="rowParts" className="row-transition">
                    <Row className={`border borderComplementaryWarrning${colorClass} bgComplementaryWarrning${colorClass}Subtle border-3 rounded-bottom-3 rounded-end-3 mb-2 bgRomerYellowParts`}>
                        {showItems}
                    </Row>
                </Col>
            </Row>
        </>
    )
}
